// src/api/mockData.js
const mockUsers = [
  {
    id: 1,
    username: 'admin',
    email: 'admin@example.com',
    password: 'admin123',
    name: '管理员'
  },
  {
    id: 2,
    username: 'user1',
    email: 'user1@example.com',
    password: 'user123',
    name: '普通用户1'
  }
];

const mockPosts = [
  {
    id: "1766735622630",
    title: "武汉美食打卡全攻略：在烟火气里吃透江湖味",
    author: "pigStar",
    date: "2025-12-26 15:53:42",
    tags: ["武汉", "美食", "攻略"],
    summary: "武汉的美食，从来都藏在市井烟火里。热干面的芝麻酱香飘满老巷，糊汤粉的鲜气裹着油条钻进鼻腔，小龙虾的麻辣在夏夜的排档里沸腾——这座被长江与汉水滋养的城市，连美食都带着江湖的豪爽与鲜活。无论是“过早”的匆忙惬意，还是正餐的酣畅淋漓，亦或是夜宵的热闹喧嚣，都值得你一一打卡。这份超全武汉美食攻略，带你从清晨吃到深夜，吃透武汉的专属味道。",
    content: `
      <p>武汉的美食，从来都藏在市井烟火里。热干面的芝麻酱香飘满老巷，糊汤粉的鲜气裹着油条钻进鼻腔，小龙虾的麻辣在夏夜的排档里沸腾——这座被长江与汉水滋养的城市，连美食都带着江湖的豪爽与鲜活。</p>
      
      <h2>武汉早餐文化</h2>
      <p>武汉人的一天是从“过早”开始的。这里的早餐不仅丰盛，更是种类繁多：</p>
      <ul>
        <li>热干面：武汉最具代表性的早餐，芝麻酱的醇厚与碱水面的劲道完美结合</li>
        <li>豆皮：金黄酥脆的外皮包裹着糯米和肉丁，口感层次丰富</li>
        <li>糊汤粉：用鱼汤煮制的米粉，鲜美无比，配上油条简直是绝配</li>
        <li>烧梅：不同于其他地方的烧卖，武汉烧梅形似石榴，口味偏辣</li>
      </ul>
      
      <h2>正餐推荐</h2>
      <p>武汉的正餐同样精彩纷呈：</p>
      <ul>
        <li>武昌鱼：清蒸武昌鱼是湖北名菜，肉质细嫩，营养丰富</li>
        <li>沔阳三蒸：蒸肉、蒸鱼、蒸蔬菜，原汁原味，健康美味</li>
        <li>排骨藕汤：莲藕炖排骨，汤鲜味美，是武汉人最爱的家常汤品</li>
      </ul>
      
      <h2>夜宵文化</h2>
      <p>武汉的夜生活从夜宵开始，特别是夏季的龙虾节，整个城市都沉浸在麻辣鲜香中。除了小龙虾，还有烧烤、炸串等各色小吃。</p>
    `,
    category: "美食",
    views: 1250,
    likes: 89,
    comments: [
      {
        id: 1,
        author: "小美食家",
        avatar: "https://api.dicebear.com/7.x/miniavs/svg?seed=1",
        content: "这篇攻略太实用了！周末就去武汉尝尝这些美食！",
        datetime: "2025-12-27 10:30",
        likes: 5,
        replies: [
          {
            id: 11,
            author: "pigStar",
            content: "欢迎来武汉品尝美食，相信你会爱上这里的味道！",
            datetime: "2025-12-27 11:00"
          }
        ]
      },
      {
        id: 2,
        author: "武汉本地人",
        avatar: "https://api.dicebear.com/7.x/miniavs/svg?seed=2",
        content: "地道的武汉美食攻略，补充一下，四季美的汤包也值得一试！",
        datetime: "2025-12-28 14:20",
        likes: 3,
        replies: []
      }
    ]
  },
  {
    id: "1766735622631",
    title: "React 18 新特性详解",
    author: "张三",
    date: "2023-10-15 12:30:42",
    tags: ["React", "JavaScript", "前端"],
    summary: "React 18 是 React 的一个重要版本，带来了许多新特性和改进。本文将详细介绍 React 18 中的主要更新和变化。",
    content: `
      <p>React 18 是 React 的一个重要版本，带来了许多新特性和改进。本文将详细介绍 React 18 中的主要更新和变化。</p>
      
      <h2>自动批处理 (Automatic Batching)</h2>
      <p>在 React 18 之前，只有在 React 事件处理器中才会进行批处理。现在，React 18 通过 ReactDOM.flushSync 扩展了批处理到所有情况，这可以减少不必要的重新渲染，提高性能。</p>
      
      <pre><code>function handleClick() {
  setCount(c => c + 1);
  setFlag(f => !f);
  // React 18 会自动批处理这些状态更新
}</code></pre>
      
      <h2>新 Hook: useId</h2>
      <p>useId 用于生成唯一 ID，特别适用于表单标签和 ARIA 属性。这有助于避免服务端渲染和客户端渲染之间的差异。</p>
      
      <h2>新 Hook: useTransition</h2>
      <p>useTransition 和 useDeferredValue 允许我们标记某些状态更新为"过渡"，这些更新可以被中断，从而保持 UI 的响应性。</p>
      
      <h2>Suspense 的改进</h2>
      <p>React 18 改进了 Suspense 的行为，使其在渲染时更可预测，并且与自动批处理一起工作。</p>
      
      <h2>并发渲染</h2>
      <p>React 18 引入了并发渲染功能，允许 React 同时准备多个版本的 UI，这有助于提高应用的响应性。</p>
      
      <p>总的来说，React 18 带来了许多性能改进和新功能，值得开发者深入了解和应用。</p>
    `,
    category: "前端开发",
    views: 2450,
    likes: 156,
    comments: [
      {
        id: 1,
        author: "李四",
        avatar: "https://api.dicebear.com/7.x/miniavs/svg?seed=3",
        content: "这篇文章写得很详细，对React 18的新特性解释得很清楚，受益匪浅！",
        datetime: "2023-10-16 10:30",
        likes: 5,
        replies: [
          {
            id: 11,
            author: "张三",
            content: "谢谢您的认可！有任何问题欢迎继续交流。",
            datetime: "2023-10-16 11:00"
          }
        ]
      },
      {
        id: 2,
        author: "王五",
        avatar: "https://api.dicebear.com/7.x/miniavs/svg?seed=4",
        content: "useTransition 这个新特性确实很有用，解决了之前一些性能问题。",
        datetime: "2023-10-17 14:20",
        likes: 3,
        replies: []
      }
    ]
  },
  {
    id: "1766735622632",
    title: "JavaScript ES2023 新特性",
    author: "李四",
    date: "2023-11-20 18:45:30",
    tags: ["JavaScript", "ES2023", "前端"],
    summary: "JavaScript ES2023 带来了许多新功能，本文将详细介绍这些新特性。",
    content: `
      <p>JavaScript ES2023 带来了许多新功能，本文将详细介绍这些新特性。</p>
      
      <h2>findLast() 和 findLastIndex()</h2>
      <p>这两个新方法允许我们从数组末尾开始查找元素。</p>
      
      <pre><code>const array = [1, 2, 3, 4, 5];
const lastEven = array.findLast(n => n % 2 === 0); // 4
const lastIndex = array.findLastIndex(n => n % 2 === 0); // 3</code></pre>
      
      <h2>Array.prototype.at()</h2>
      <p>用于获取数组中指定索引的元素，支持负数索引。</p>
      
      <pre><code>const array = [1, 2, 3, 4, 5];
console.log(array.at(-1)); // 5</code></pre>
      
      <h2>Symbol.prototype.description</h2>
      <p>现在可以通过 description 属性获取 Symbol 的描述信息，而无需调用 toString() 方法。</p>
      
      <h2>WeakMap 和 WeakSet 的增强</h2>
      <p>ES2023 对 WeakMap 和 WeakSet 进行了一些改进，使其更加实用。</p>
    `,
    category: "前端开发",
    views: 1230,
    likes: 89,
    comments: [
      {
        id: 1,
        author: "赵六",
        avatar: "https://api.dicebear.com/7.x/miniavs/svg?seed=5",
        content: "ES2023的新特性确实让JavaScript变得更强大了！",
        datetime: "2023-11-21 09:15",
        likes: 2,
        replies: []
      }
    ]
  },
  {
    id: "1766735622633",
    title: "Node.js 性能优化指南",
    author: "Node专家",
    date: "2024-01-10 14:20:15",
    tags: ["Node.js", "性能", "后端"],
    summary: "Node.js 应用的性能优化是每个开发者都需要掌握的技能。本文将分享一些实用的优化技巧。",
    content: `
      <p>Node.js 应用的性能优化是每个开发者都需要掌握的技能。本文将分享一些实用的优化技巧。</p>
      
      <h2>使用 Cluster 模块</h2>
      <p>Node.js 默认是单线程的，为了充分利用多核 CPU，我们可以使用 Cluster 模块创建多个进程。</p>
      
      <pre><code>const cluster = require('cluster');
const numCPUs = require('os').cpus().length;

if (cluster.isMaster) {
  for (let i = 0; i < numCPUs; i++) {
    cluster.fork();
  }
} else {
  // 启动应用
  require('./app');
}</code></pre>
      
      <h2>内存管理优化</h2>
      <p>避免内存泄漏是性能优化的关键：</p>
      <ul>
        <li>及时清理定时器和事件监听器</li>
        <li>使用流处理大数据</li>
        <li>合理使用缓存策略</li>
      </ul>
      
      <h2>异步编程优化</h2>
      <p>合理使用 async/await 和 Promise，避免阻塞事件循环。</p>
    `,
    category: "后端开发",
    views: 3120,
    likes: 205,
    comments: [
      {
        id: 1,
        author: "后端开发者",
        avatar: "https://api.dicebear.com/7.x/miniavs/svg?seed=6",
        content: "很好的性能优化指南，特别是Cluster部分对我帮助很大！",
        datetime: "2024-01-11 16:45",
        likes: 7,
        replies: [
          {
            id: 11,
            author: "Node专家",
            content: "感谢认可！如果有其他问题欢迎交流。",
            datetime: "2024-01-11 17:00"
          }
        ]
      }
    ]
  },
  {
    id: "1766735622634",
    title: "CSS Grid 布局完全指南",
    author: "CSS大师",
    date: "2024-02-05 11:30:25",
    tags: ["CSS", "布局", "前端"],
    summary: "CSS Grid 是现代网页布局的强大工具，本文将详细介绍Grid的各种用法和最佳实践。",
    content: `
      <p>CSS Grid 是现代网页布局的强大工具，本文将详细介绍Grid的各种用法和最佳实践。</p>
      
      <h2>基础概念</h2>
      <p>Grid 布局是一种二维布局系统，它允许我们在行和列中同时排列元素。</p>
      
      <pre><code>.container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
}</code></pre>
      
      <h2>网格模板区域</h2>
      <p>使用 grid-template-areas 可以直观地定义页面布局结构：</p>
      
      <pre><code>.container {
  grid-template-areas: 
    "header header header"
    "sidebar main aside"
    "footer footer footer";
}</code></pre>
      
      <h2>响应式网格</h2>
      <p>结合媒体查询，我们可以创建响应式的网格布局：</p>
      
      <pre><code>@media (max-width: 768px) {
  .container {
    grid-template-columns: 1fr;
  }
}</code></pre>
    `,
    category: "前端开发",
    views: 1890,
    likes: 132,
    comments: [
      {
        id: 1,
        author: "前端新手",
        avatar: "https://api.dicebear.com/7.x/miniavs/svg?seed=7",
        content: "Grid布局真的比Flexbox更适合复杂布局，学习了！",
        datetime: "2024-02-06 08:20",
        likes: 4,
        replies: []
      }
    ]
  },
  {
    id: "1766735622635",
    title: "Docker 容器化部署实战",
    author: "DevOps工程师",
    date: "2024-03-15 16:45:50",
    tags: ["Docker", "容器", "部署"],
    summary: "Docker已经成为现代应用部署的标准工具，本文将通过实例讲解如何使用Docker进行应用容器化。",
    content: `
      <p>Docker已经成为现代应用部署的标准工具，本文将通过实例讲解如何使用Docker进行应用容器化。</p>
      
      <h2>基本概念</h2>
      <p>Docker 使用容器来打包应用及其依赖，确保应用在任何环境中都能一致运行。</p>
      
      <h2>创建 Dockerfile</h2>
      <p>编写一个简单的 Node.js 应用的 Dockerfile：</p>
      
      <pre><code>FROM node:16-alpine
WORKDIR /app
COPY package*.json ./
RUN npm install
COPY . .
EXPOSE 3000
CMD ["npm", "start"]</code></pre>
      
      <h2>构建和运行镜像</h2>
      
      <pre><code># 构建镜像
docker build -t my-app .

# 运行容器
docker run -p 3000:3000 my-app</code></pre>
      
      <h2>Docker Compose</h2>
      <p>对于多服务应用，使用 docker-compose.yml 更方便管理：</p>
      
      <pre><code>version: '3'
services:
  web:
    build: .
    ports:
      - "3000:3000"
  redis:
    image: "redis:alpine"</code></pre>
    `,
    category: "DevOps",
    views: 2780,
    likes: 187,
    comments: [
      {
        id: 1,
        author: "运维小白",
        avatar: "https://api.dicebear.com/7.x/miniavs/svg?seed=8",
        content: "Docker确实让部署变得简单多了，不过刚开始学起来有点困难。",
        datetime: "2024-03-16 10:15",
        likes: 3,
        replies: [
          {
            id: 11,
            author: "DevOps工程师",
            content: "坚持学习，熟练掌握后会让工作效率大大提升！",
            datetime: "2024-03-16 11:00"
          }
        ]
      }
    ]
  }
];

const mockAboutInfo = {
  title: "关于我",
  content: "这是一个关于我的页面，介绍博客的作者和目的。",
  updated: "2023-10-15"
};

export { mockUsers, mockPosts, mockAboutInfo };